module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/antiBacterial@2x_9f5605.png";